import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setCalendarBlockInputDepartureDate } from 'Store/calendar/calendar.action';
import {
  getDepartureDateBookable,
  getBlockInputDepartureDate,
} from 'Store/calendar/calendar.selector';
export function useBlockInputDepartureDate(checkIfDepartureDateIsBookable: boolean = false) {
  const departureDateIsBookable: boolean = useSelector(getDepartureDateBookable);
  const blockInputDepartureDate = useSelector(getBlockInputDepartureDate);
  const dispatch = useDispatch();

  const setBlockInputDepartureDate = (value: boolean) => {
    if (value !== blockInputDepartureDate) {
      dispatch(setCalendarBlockInputDepartureDate(value));
    }
  };

  useEffect(() => {
    if (departureDateIsBookable) {
      setBlockInputDepartureDate(false);
    }
  }, [departureDateIsBookable]);
  return {
    blockInputDepartureDate: checkIfDepartureDateIsBookable && blockInputDepartureDate,
    departureDateIsBookable,
    setBlockInputDepartureDate,
  };
}
